<template>
    <div class="page-nav page-card">
        <div class="header-left">
            <ul class="nav-menu">
                <li class="menu-item" v-show="isShowBack">
                    <span class="icon back" @click="Back">返回</span>
                </li>
                <li class="menu-item" style="padding: 0;width: 1px;" v-show="isShowBack">
                    <div style="height: 42px;width: 1px;background-color: #DDD;"></div>
                </li>
                <li class="menu-item" v-for="menu in menus" :key="menu">{{menu.title}}</li>
                <li class="menu-item" style="float:right;">{{nowTime}}</li>
            </ul>
        </div>
    </div>
</template>
<style type="text/css" scoped>
    .icon {
        background-repeat: no-repeat;
        background-position: left center;
        display: inline-block;
    }

    .back {
        background-image: url('~assets/u397.png');
        padding-left: 32px;
        padding-right: 10px;
        background-position-x: 5px;
    }

    .page-nav .menu-item {
        text-align: center;
    }

</style>
<script>
    import utils from 'utils'
    export default {
        data() {
            return {
                nowTime: utils.DateFormat(new Date(), "yyyy-MM-dd HH:mm:ss")
            }
        },
        props: ['menus', 'showBack'],
        methods: {
            Back() {
                history.back();
            }
        },
        computed: {
            isShowBack() {
                return this.showBack == undefined || (this.showBack != false && this.showBack != "false");
            }
        },
        mounted() {
            var __self = this;
            setInterval(function () {
                __self.nowTime = utils.DateFormat(new Date(), "yyyy-MM-dd HH:mm:ss")
            }, 1000);
        }
    }

</script>



// WEBPACK FOOTER //
// page-nav.vue?cd049bfe